
export function elementsBoundToContext(elements, contextName) {
  if (!contextName) {
    return [];
  }
  return (elements ?? []).filter(
    element => element?.parsedOptions?.context?.entityContext === contextName,
  );
}

export function renameContextBindings(elements, fromName, toName) {
  if (!fromName || !toName || fromName === toName) {
    return [];
  }
  return elementsBoundToContext(elements, fromName).map(element => ({
    element,
    options: {
      ...element.parsedOptions,
      context: {
        ...element.parsedOptions.context,
        entityContext: toName,
      },
    },
  }));
}

export function renameContextEntries(entries, fromName, toName) {
  const source = entries ?? {};
  if (!fromName || !toName || fromName === toName) {
    return { ...source };
  }
  const renamed = {};
  Object.entries(source).forEach(([name, entry]) => {
    const key = name === fromName ? toName : name;
    renamed[key] = entry?.sourceContext === fromName
      ? { ...entry, sourceContext: toName }
      : entry;
  });
  return renamed;
}

const CONTEXT_LEAF_SOURCES = ["context", "contextField"];
const CONTEXT_BIND_KINDS = ["context", "contextField"];

function renamedNode(node, fromName, toName) {
  if (Array.isArray(node)) {
    let changed = false;
    const items = node.map(item => {
      const next = renamedNode(item, fromName, toName);
      changed = changed || next !== item;
      return next;
    });
    return changed ? items : node;
  }
  if (!node || typeof node !== "object") {
    return node;
  }
  let changed = false;
  const next = {};
  Object.entries(node).forEach(([key, value]) => {
    const renamed = renamedNode(value, fromName, toName);
    changed = changed || renamed !== value;
    next[key] = renamed;
  });
  if (CONTEXT_LEAF_SOURCES.includes(next.source) && next.context === fromName) {
    next.context = toName;
    changed = true;
  }
  if (CONTEXT_BIND_KINDS.includes(next.kind) && next.context === fromName) {
    next.context = toName;
    changed = true;
  }
  if (next.kind === "contextField" && next.contextEntity === fromName) {
    next.contextEntity = toName;
    changed = true;
  }
  if (next.entitySource === "context" && next.sourceContext === fromName) {
    next.sourceContext = toName;
    changed = true;
  }
  return changed ? next : node;
}

export function renameValueContextReferences(options, fromName, toName) {
  if (!fromName || !toName || fromName === toName) {
    return options;
  }
  return renamedNode(options, fromName, toName);
}
